import { render, staticRenderFns } from "./zLoading.vue?vue&type=template&id=80401a4c&scoped=true&"
import script from "./zLoading.vue?vue&type=script&lang=js&"
export * from "./zLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80401a4c",
  null
  
)

export default component.exports